import React, { useState } from "react";
import MainLayout1 from "Components/UI/Layout/MainLayout1";
import Typography from "@mui/material/Typography";
import Paper from "Components/UI/Paper";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { PAYRULES_OPTIONS } from "utils/options/PAYRULES_OPTIONS";
import {
  useNavigate,
  useLoaderData,
  useRouteLoaderData,
} from "react-router-dom";
import { createClientArticle as createClientArticleReq } from "API/swesum";
import usePost from "Hooks/usePost";
import ClientArticleForm from "Components/Article/ClientArticleForm";
import { usePayRules } from "Context/PayRules";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const initialState = {
  Name: "",
  DebetAccount: "",
  KreditAccount: "",
  VAT: "",
  Payrule: "",
  ParseMessage: "",
  ParseStatus: "",
  CreateTime: "",
};

export default function CreateClientArticle() {
  const [formData, setFormData] = useState(initialState);
  const { payRules } = usePayRules();
  const { openError } = usePopupNotificationContext();
  const payRuleOptions = PAYRULES_OPTIONS;
  const createArticleReq = usePost({
    mtnFunc: (body) => createClientArticleReq(body),
    onError: () => {
      openError("Ett fel uppstod när artikeln skapades.");
    },
    onSuccess: (data) => {
      // navigate(`/clientsarticles/${data.ClientArticleId}`);
      navigate(`/clientsarticles/${data.Id}`);
    },
  });

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  return (
    <>
      <MainLayout1>
        <Paper>
          <Typography sx={{ marginBottom: "2rem" }} variant="h5">
            Skapa klientartikel
          </Typography>
          <ClientArticleForm
            formData={formData}
            handleInputChange={handleInputChange}
            payRuleOptions={payRules}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 4,
            }}
          >
            <Stack direction="row" spacing={3}>
              <Button onClick={() => navigate(-1)}>Stäng</Button>
              <Button
                onClick={() => createArticleReq.post(formData)}
                variant="contained"
              >
                Spara
              </Button>
            </Stack>
          </Box>
        </Paper>
      </MainLayout1>
    </>
  );
}
